/**
 * Frontend API for interacting with the KajabiChatBot API
 */
import { createApiRef } from "@backstage/core";
import { DiscoveryApi } from "@backstage/core-plugin-api";

/** Create an API Ref */
export const kajabiChatBotApiRef = createApiRef<KajabiChatBotApi>({
  id: "plugin.kajabi-chat-bot-api.service",
  description: "Used by plugins to make requests to KajabiChatBot",
});

export type Options = {
  discoveryApi: DiscoveryApi;
};

/**
 * Frontend API for interacting with the KajabiChatBot API
 */
export class KajabiChatBotApi {
  /** Discovery Api */
  private readonly discoveryApi: DiscoveryApi;

  /**
   * Constructor
   */
  constructor(options: Options) {
    this.discoveryApi = options.discoveryApi;
  }

  /** Retrieve the primary URL  */
  private async getUrl(): Promise<string> {
    return await this.discoveryApi.getBaseUrl("kajabi-chat-bot-api");
  }

  /**
   * Placeholder. Making available for when needed.
   */
  public async test(): Promise<string> {
    const url = await this.getUrl();
    return url;
  }
}
